<template>
  <div class="item-container">
    <div class="lbl">
      <span>{{ header }}</span>
      <span v-if="toolTipIconShow" 
            v-b-tooltip.right.nofade="toolTipDelay" 
            :title="toolTipText" 
            class="info-icon-tooltip">
        <font-awesome-icon :icon="['fas', 'info-circle']" />
      </span>
    </div>
    <div class="tree">
      <treeselect ref="kpiTreeselect"
                  v-model="itemData.selected"
                  class="custom-tree"
                  :placeholder="placeholder"
                  :clearable="false"
                  :options="itemData.options"
                  valueFormat="object"
                  :disableFuzzyMatching="true"
                  :multiple="false"
                  :showCount="true"
                  :limit="2"
                  :isLoading="isLoading"
                  :limit-text="limitText"
                  showCountOf="LEAF_DESCENDANTS"
                  :defaultExpandLevel="0">
        <label slot="option-label" slot-scope="{ node, labelClassName }" :class="labelClassName">
          <span v-b-tooltip.right.nofade="toolTipDelay" :title="getKpiLongtextToolTip(node.id)">
            <font-awesome-icon  :icon="['fas', 'info-circle']" />
          </span> {{ node.label }} 
        </label>
      </treeselect>
    </div>
  </div>
</template>

<script>
import EventBus from "@/services/EventBus.js";
import AppConfig from "@/mixins/AppConfig-APP_TARGET";
import ToolTipProvider from '@/mixins/bmw/ToolTipProvider.js';

export default {
  mixins: [ AppConfig, ToolTipProvider ],
  
  props: {
    header: String,
    placeholder: String,
    isLoading: Boolean,
    selectedBrand: { type: String, required: true },
    selectedEventName: String,
    itemsListenEventName: String,
    toolTipIconShow: { type: Boolean, default: false }, // Show info Icon right next to header text
    toolTipText: { type: String, default: 'Tooltiptext' }
  },

  data() {
    return {
      itemData: {
        selected: null,
        options: [],
      }
    }
  },

  watch: {
    'itemData.selected': {
      handler(newVal, oldVal) {
        if (oldVal != newVal)
          EventBus.$emit(this.selectedEventName, newVal);
      }
    }
  },

  mounted() {
    EventBus.$on('selected-brand-switched', this.initTooltips);
  },

  created() {
    EventBus.$on(this.itemsListenEventName, this.setItemData);
  },

  beforeDestroy() {
    EventBus.$off(this.itemsListenEventName, this.setItemData);
    EventBus.$off('selected-brand-switched', this.initTooltips);
  },

  methods: {

    setItemData(data) {
      this.itemData.selected = null;
      this.itemData.options = data.items;
      this.itemData.selected = data.selected;
    }
  }
}

</script>

<style scoped>

.custom-tree {
  padding-right: 4px;
  padding-top: 4px;   
}

.item-container {
  display: grid;
  grid-template-columns: auto auto;
  margin: auto;
}

.lbl {
  text-align: left;
  vertical-align: left;
  vertical-align: middle;
  min-width: 4rem;
  line-height: 3.3em;
}

.tree {
  vertical-align: middle;
}

</style>
